import api from "app/lib/api";
import * as fileDownload from "js-file-download";
import endpoints from "static/endpoints";
import { getFormattedDateTime } from "utils/date";

export const getDoctors = async ({
  startDate,
  endDate,
  account,
  sort,
  name,
  isExport,
}) => {
  let url =
    isExport === true
      ? endpoints.dashboard.doctorsReport
      : endpoints.dashboard.doctors;

  if (startDate && endDate) {
    url += `?startDate=${startDate}&endDate=${endDate}&`;

    if (account || sort || name) {
      url += [
        account && `account=${account}`,
        sort && `sort=${sort}`,
        name && `name=${name}`,
      ]
        .filter(Boolean)
        .join("&");
    }

    if (isExport === true) {
      await api
        .get(url, { responseType: "blob" })
        .then((response) => {
          fileDownload(
            response.data,
            `doctors-report-${getFormattedDateTime()}.csv`
          );
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    } else {
      const { data } = await api.get(url);

      return data;
    }
  }
};
